var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-new-order section-full"},[_c('form-staff',{attrs:{"title":_vm.$gettext('Add Staff')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }